<section id="imprint">
    <div class="content">
            <h1>{{text.imprint}}</h1>
            <p>{{text.law}}</p>
            <p>Irina Gorges<br>
                Bachstr. 37<br>
                37574 Einbeck<br>
            </p>
            <p><strong>{{text.contact}}:</strong> <br>
                {{text.phone}}: 0170-6465231<br>
                E-Mail: <a href='mailto:irinagorges&#64;live.de'>irinagorges&#64;live.de</a></p>
        </div>
</section>